export const ColumnsContainer = ({
  children,
}: { children: React.ReactNode }) => {
  return (
    <div className="flex h-full flex-1 shrink-0 gap-2 px-2 pt-2">
      {children}
    </div>
  );
};
